import { useEffect, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "../../app/hook";
import { handleSetAiSpeedType, wizardState } from "./botSlice";
import { AIKittyType } from "./types";
import { Form } from "react-bootstrap";

type Props = {
  formBuilder: UseFormReturn<any, any>;
};
const ReactionSpeedEdit = ({ formBuilder }: Props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const wizard = useAppSelector(wizardState);

  const [data, setData] = useState([
    {
      key: "SMART",
      select: false,
      title: "AssistantSpeedPage/l-1"
    },
    {
      key: "SMART_FAST",
      select: false,
      title: "AssistantSpeedPage/l-2"
    },
    {
      key: "FAST_SMART",
      select: false,
      title: "AssistantSpeedPage/l-3"
    },
    {
      key: "FAST",
      select: false,
      title: "AssistantSpeedPage/l-4"
    }
  ]);

  useEffect(() => {
    formBuilder.setValue(
      "model",
      (wizard.bot_config as AIKittyType).modelTitle
    );
  }, [(wizard.bot_config as AIKittyType).modelTitle]);

  return (
    <div className="tw-grid tw-grid-cols-12 sm:tw-gap-0 md:tw-gap-0 xl:tw-gap-7">
      <div className="md:tw-col-span-9 tw-col-span-12 tw-flex-col tw-justify-start tw-tw-items-start tw-inline-flex md:tw-w-[80%] tw-w-full">
        <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-8 tw-flex tw-mb-8 tw-w-full">
          <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-2 tw-flex">
            <div className="tw-self-stretch tw-text-gray-900 tw-text-2xl tw-font-semibold tw-font-['Lexend'] tw-leading-loose">
              {t("Wizard/ReactionSpeed/key1")}
            </div>
            <div className="tw-self-stretch tw-text-gray-900 text-sm font-normal tw-font-['Lexend'] tw-leading-tight">
              {t("Wizard/ReactionSpeed/key2")}
            </div>
          </div>
          {formBuilder.formState.errors.model && (
            <div className="tw-self-stretch tw-text-red-600 tw-text-xs tw-font-['Lexend'] tw-leading-none tw-block">
              {formBuilder.formState.errors?.model?.message as string}
            </div>
          )}
        </div>
        <Form.Group className="">
          <Form.Select
            className="tw-h-10 tw-px-4 tw-py-2.5 tw-bg-white tw-rounded-md tw-shadow-sm tw-border tw-border-gray-300 lg:tw-w-1/3 tw-w-full"
            {...formBuilder.register("model", {
              onChange: (e) => {
                dispatch(handleSetAiSpeedType(e.target.value));
              }
            })}
          >
            {data?.map((dr, index) => (
              <option key={dr.key} value={dr.key}>
                {t(dr.title)}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </div>
    </div>
  );
};

export default ReactionSpeedEdit;
